import React, { useState } from 'react';
import { useEffect } from 'react';

import { List, notification, Popover } from 'antd';
import { set } from 'lodash';

import styled from 'styled-components';

import MiniLoading from '@components/Gui/MiniLoading';
import { NwLinkButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .ant-dropdown-menu-item-group-list {
        max-height: unset;
    }
`;

const Content = styled.div`
    padding: 0.25rem 0.75rem 0.5rem 0.75rem;
    min-width: 22rem;

    .ant-menu-item-group-title {
        padding: 6px 0;
    }

    .ant-list-item {
        padding: 6px 0;

        .ant-list-item-meta {
            align-items: center;
        }

        .ant-list-item-meta-title {
            margin-bottom: 0;
            text-transform: uppercase;
            font-size: 0.8rem;
            font-weight: normal;
        }
    }

    .loading-message {
        padding: 2rem;
        text-align: center;
    }
`;

const TemplateSelectorPopover = ({ children, onSelect, placement, templates, trigger }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const handleSelectTemplate = async (templateID) => {
        setLoading(true);
        // handle error on onSelect
        try {
            const response = await onSelect(templateID);
        } catch (error) {
            notification.error({
                message: 'Error',
                description: error.message,
            });
        }
        setOpen(false);
        setLoading(false);
    };

    return (
        <Wrapper>
            <Popover
                zIndex={9999}
                overlayClassName="folder-popover"
                placement={placement || 'top'}
                trigger={trigger || 'click'}
                open={open}
                onOpenChange={handleOpenChange}
                content={
                    <Content>
                        {loading ? (
                            <div className="loading-message">
                                <MiniLoading size="lg" /> Generating document, please wait...
                            </div>
                        ) : (
                            <>
                                <div role="presentation" className="ant-menu-item-group-title" title="print book">
                                    SELECT A PRINT LAYOUT
                                </div>
                                <List
                                    itemLayout="horizontal"
                                    dataSource={templates}
                                    renderItem={(item) => (
                                        <List.Item>
                                            <List.Item.Meta
                                                avatar={<NwIcon icon={byPrefixAndName.fasl['file-pdf']} />}
                                                title={
                                                    <NwLinkButton
                                                        label={item.name}
                                                        onClick={() => handleSelectTemplate(item.id)}
                                                    />
                                                }
                                                description=""
                                            />
                                        </List.Item>
                                    )}
                                />
                            </>
                        )}
                    </Content>
                }
            >
                {children}
            </Popover>
        </Wrapper>
    );
};

export default TemplateSelectorPopover;
